import List from './views/List.vue'
import Create from './views/Create.vue'

export const CopyPayrollRequestRoutes = [
  {
    path: '/payroll-copy-requests',
    name: 'ListCopyPayrollRequest',
    component: List,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'payroll_copy_request:list'
    }
  },
  {
    path: '/payroll-copy-request',
    name: 'CreateCopyPayrollRequest',
    component: Create,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'payroll_copy_request:bulk'
    }
  }
]
